<template>
	<div class="landingpage-filters-container">
		<div class="landingpage-filter-items d-flex flex-v-centre flex-h-between">
			<div class="select-holder">
				<CustomMultiSelect id="TeamsFilter" name="TeamsFilter" v-model="selectedTeams" :options="distinctTeamTags" placeholder="Filter Teams" show-clear :select-all="false" append-to="self" :maxSelectedLabels="1" :selectedItemsLabel="`${selectedTeams?.length} Teams selected`"> </CustomMultiSelect>
			</div>
			<div class="select-holder">
				<CustomMultiSelect id="DatesFilter" name="DatesFilter" v-model="selectedDates" :options="distinctDates" placeholder="Filter Dates" show-clear :select-all="false" append-to="self" :maxSelectedLabels="1" :selectedItemsLabel="`${selectedDates?.length} Dates selected`"> </CustomMultiSelect>
			</div>
			<div class="select-holder">
				<CustomMultiSelect id="LocationsFilter" name="LocationsFilter" v-model="selectedLocations" :options="distinctLocations" placeholder="Filter Locations" show-clear :select-all="false" append-to="self" :maxSelectedLabels="1" :selectedItemsLabel="`${selectedLocations?.length} Locations selected`"> </CustomMultiSelect>
			</div>
		</div>
		<hr class="grey-fade" />
	</div>
	<div v-if="items" class="landingpage-content-packages">
		<div class="d-flex flex-wrap">
			<GameTileListCe :items="filteredGames" :layout="layout"></GameTileListCe>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import type { GameTileItemModel } from '@/types/GameTileItemModel';
	import { parse } from 'date-fns';
	import { sortBy } from 'lodash';
	import { computed, ref } from 'vue';
	import CustomMultiSelect from './CustomMultiSelect.vue';
	import GameTileListCe from './GameTileList.ce.vue';

	const props = defineProps({
		items: {
			type: String,
			required: true,
		},
		layout: String,
		team: {
			type: String,
			required: false,
		},
	});

	const games = ref<Array<GameTileItemModel>>(JSON.parse(props.items));

	const selectedTeams = ref<Array<string>>([]);

	if (props.team) {
		selectedTeams.value.push(props.team);
	}

	const selectedLocations = ref<Array<string>>([]);
	const selectedDates = ref<Array<string>>([]);
	const distinctTeamTags = computed(() => [...new Set(games.value.flatMap(g => g.TeamTags))].sort());
	const distinctLocations = computed(() => [...new Set(games.value.flatMap(game => game.LocationTags))].sort());
	const distinctDates = computed(() => {
		const dateFormats = ['MMM yyyy', 'MMMM yyyy'];
		return sortBy([...new Set(games.value.flatMap(game => game.DateTags))], date => {
			for (const dateFormat of dateFormats) {
				const parsed = parse(date, dateFormat, new Date());
				if (!isNaN(parsed.getTime())) {
					return parsed;
				}
			}
			console.error('Could not parse date', date);
		});
	});

	const filteredGames = computed(() => {
		let filtered = games.value;

		if (selectedTeams.value?.length > 0) {
			filtered = games.value.filter(g => g.TeamTags.some(t => selectedTeams.value.includes(t)));
		}
		if (selectedLocations.value?.length > 0) {
			filtered = games.value.filter(g => g.LocationTags.some(l => selectedLocations.value.includes(l)));
		}
		if (selectedDates.value?.length > 0) {
			filtered = games.value.filter(g => g.DateTags.some(d => selectedDates.value.includes(d)));
		}

		return JSON.stringify(filtered);
	});
</script>
